/** How a period is named on screen: "September 2026", "Quarter 3 2026", "2026" or a range. */
import type { TFunction } from "i18next";
import type { Period } from "@/lib/at/periods";
import { formatDate } from "@/lib/utils/format";

/** Month names are keyed by number in en.json; the tuple keeps the lookup type-checked. */
export const MONTH_KEYS = [
  "months.1",
  "months.2",
  "months.3",
  "months.4",
  "months.5",
  "months.6",
  "months.7",
  "months.8",
  "months.9",
  "months.10",
  "months.11",
  "months.12",
] as const;

export type PeriodMode = "month" | "quarter" | "year" | "custom";

export function modeOf(period: Period): PeriodMode {
  if (period.kind === "monthly") return "month";
  if (period.kind === "quarterly") return "quarter";
  return period.index === 0 ? "custom" : "year";
}

/** "September 2026", "Quarter 3 2026", "2026" or "Aug 20, 2026 – Sep 19, 2026". */
export function periodLabel(period: Period, t: TFunction): string {
  switch (modeOf(period)) {
    case "month":
      return `${t(MONTH_KEYS[period.index - 1]!)} ${period.year}`;
    case "quarter":
      return `${t("reports.quarter", { index: period.index })} ${period.year}`;
    case "year":
      return String(period.year);
    default:
      return `${formatDate(period.from)} – ${formatDate(period.to)}`;
  }
}
